"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChilePaymentOptionsParser = void 0;
var _PaymentOptionsParser = require("../generic/PaymentOptionsParser");
class ChilePaymentOptionsParser extends _PaymentOptionsParser.PaymentOptionsParser {
  getPaymentOptionsIcons() {
    return {
      firstContainer: {
        bci: '/assets/ws10/icons/entel/bci.png',
        entelVisa: '/assets/ws10/icons/entel/entel-visa.png',
        itau: '/assets/ws10/icons/entel/itau.png',
        santander: '/assets/ws10/icons/entel/santander.png',
        scotiabank: '/assets/ws10/icons/entel/scotiabank.png'
      },
      banco: '/assets/ws10/icons/entel/banco-de-chile.png',
      visa: '/assets/ws10/icons/entel/visa.png',
      mastercard: '/assets/ws10/icons/entel/mastercard.png'
    };
  }
}
exports.ChilePaymentOptionsParser = ChilePaymentOptionsParser;